<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button> </ion-button>
    <ion-title>{{'Atenção' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

  <div class="gradient-extendido" *ngIf="loaded"></div>

  <ion-grid *ngIf="loaded">
    <ion-row>
      <ion-col size="12" class="ion-paddin-end ion-padding-start ion-margin-bottom">
        <div class="text-center">
          <p>
            {{'Ao acessar este aplicativo declaro que estou de acordo com a Política de Privacidade
            e Termo de Uso' | translate}}.
          </p>
        </div>

        <div class="text-center" *ngIf="dependentes.length > 0">
          <p>
            {{'Confirmo o meu consentimento para o tratamento de dados de meus dependentes
            relacionados abaixo já cadastrados no sistema' | translate}}:
          </p>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col *ngIf="dependentes.length > 0" size="12">
        <p class="dependentes">{{'Dependentes' | translate}}</p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" class="remove-border">
        <ion-list *ngFor="let d of dependentes">
          <ion-item class="top">
            <ion-avatar slot="start">
              <img [src]="d.foto | image:''" class="avatar-image" />
            </ion-avatar>

            <ion-label>
              <h2>{{d.nome}}</h2>
              <p class="parentesco">{{d.parentesco}}</p>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>

    <ion-row class="top">
      <ion-col size="12" class="btn-col">
        <ion-list>
          <ion-button
            expand="block"
            fill="outline"
            class="button-filter"
            type="button"
            (click)="politicas()"
          >
            {{'Políticas de Privacidade' | translate}}
          </ion-button>
        </ion-list>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" class="btn-col">
        <ion-list>
          <ion-button
            expand="block"
            fill="outline"
            class="button-filter"
            type="button"
            (click)="termos()"
          >
            {{'Termos de Uso' | translate}}
          </ion-button>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer *ngIf="loaded">
  <ion-button expand="block" class="btn-default" (click)="aceito()">
    {{'ENTENDI E ACEITO' | translate}}
  </ion-button>
</ion-footer>
